import React, { Component, useRef, useState } from "react";
import Barcode from "react-barcode";
import CartContext from "./CartContext";

import {
  Form,
  Table,
  FloatingLabel,
  Button,
  Row,
  Col,
  Card,
  Stack,
} from "react-bootstrap";
import { SideMenu } from "./SideMenu";
import ReactToPrint from "react-to-print";

// export class BarCodeCustom extends Component {
//   static contextType = CartContext;

//   constructor(props) {
//     super(props);
//     this.state = {
//       barcode: "",
//       totalcount: 10,
//       arr: [],
//     };
//     useRef myref="";
//   }

const pageStyle = `
    @page {size:30mm 20mm};
    @media all {
    .pageBreak{display:none}
  };
  @media print{
  .pageBreak{ page-Break-before:always;}
  }
    }
    `;

export function BarCodeCustom(props) {
  const [barCode, SetBarCode] = useState("");
  const [label, SetLabel] = useState("");
  const [totalcount, SetTotalCount] = useState(10);
  const [arr, SetArr] = useState([]);
  const [labelFontSize, SetLabelFontSize] = useState("12");
  const [barCodeHeight, SetBarCodeHeight] = useState("40");
  const [barCodeWidth, SetBarCodeWidth] = useState("1");
  const myref = useRef();

  const Generate = () => {
    // var barcode = getBarcode();
    if (barCode == "") {
      alert("Barcode is empty!");
      return;
    }
    var tarr = [];
    for (let i = 1; i <= totalcount; i++) {
      tarr.push({ barcode: barCode, label: label });
    }
    SetArr(tarr);
  };
  // const Print = () => {
  //   var printContents = document.getElementById("divcontents").innerHTML;
  //   //var originalContents = document.body.innerHTML;
  //   //document.body.innerHTML = printContents;
  //   // window.print();
  //   //document.body.innerHTML = originalContents;

  //   var printWindow = window.open("", "_blank");
  //   printWindow.document.write(printContents);
  //   printWindow.document.close();
  //   this.onPrintFinished(printWindow.print(), printWindow);
  // };

  const onPrintFinished = (status, printWindow) => {
    var osvar = this.getOS();
    if (osvar == "Windows") printWindow.close();
  };
  const getOS = () => {
    var uA = navigator.userAgent || navigator.vendor || window.opera;
    if (
      (/iPad|iPhone|iPod/.test(uA) && !window.MSStream) ||
      (uA.includes("Mac") && "ontouchend" in document)
    )
      return "iOS";

    var i,
      os = ["Windows", "Android", "Unix", "Mac", "Linux", "BlackBerry"];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], "i").test(uA)) return os[i];
  };

  const getBarcode = () => {
    var currentTime = new Date();
    var currentOffset = currentTime.getTimezoneOffset();
    var ISTOffset = 330; // IST offset UTC +5:30
    var ISTTime = new Date(
      currentTime.getTime() + (ISTOffset + currentOffset) * 60000
    );

    var code =
      ISTTime.getFullYear() +
      "" +
      (ISTTime.getMonth() + 1) +
      "" +
      ISTTime.getDate() +
      "" +
      ISTTime.getMinutes() +
      "" +
      ISTTime.getSeconds() +
      "" +
      ISTTime.getMilliseconds();
    // this.setState({ barcode: code });
    return code;
  };

  return (
    <>
      <h2 className="bg-light">Generate or Re-Generate Barcodes</h2>

      <Row className="w-100 m-1 p-3 justify-content-top CornersRounded bg-light border">
        {/* Total Count Input */}

        {/* Barcode & Label Inputs */}
        <Col xs={12} md={8}>
          <Row className="g-2 text-start">
            <Col xs={12} md={4} className="d-grid gap-2">
              <Button
                size="lg"
                variant="primary"
                onClick={() => SetBarCode(getBarcode())}
              >
                Create New Barcode
              </Button>
              <Button size="lg" variant="warning" onClick={Generate}>
                GENERATE BARCODES
              </Button>
            </Col>
            <Col xs={12} md={8}>
              <FloatingLabel label="Enter/Scan Barcode" className="mb-3">
                <Form.Control
                  type="text"
                  size="lg"
                  value={barCode}
                  onChange={(e) => SetBarCode(e.target.value)}
                  className="mb-2"
                  autoComplete="off"
                />
              </FloatingLabel>
              <FloatingLabel label="Enter Label Name" className="mb-3">
                <Form.Control
                  type="text"
                  size="lg"
                  value={label}
                  onChange={(e) => SetLabel(e.target.value)}
                  autoComplete="off"
                />
              </FloatingLabel>

              <FloatingLabel
                label="Enter Total Barcodes Required"
                className="mb-3"
              >
                <Form.Control
                  type="text"
                  size="lg"
                  value={totalcount}
                  onChange={(e) => SetTotalCount(e.target.value)}
                  autoComplete="off"
                />
              </FloatingLabel>
            </Col>
          </Row>
        </Col>

        {/* Label Size / Height / Width */}
        <Col xs={12} md={3}>
          <FloatingLabel label="Label FontSize" className="mb-3">
            <Form.Control
              type="text"
              size="lg"
              placeholder="Label FontSize"
              value={labelFontSize}
              onChange={(e) => SetLabelFontSize(e.target.value)}
              autoComplete="off"
            />
          </FloatingLabel>
          <FloatingLabel label="Barcode Height" className="mb-3">
            <Form.Control
              type="text"
              size="lg"
              placeholder="Barcode Height"
              value={barCodeHeight}
              onChange={(e) => SetBarCodeHeight(e.target.value)}
              autoComplete="off"
            />
          </FloatingLabel>
          <FloatingLabel label="Barcode Width" className="mb-3">
            <Form.Control
              type="text"
              size="lg"
              placeholder="Barcode Width"
              value={barCodeWidth}
              onChange={(e) => SetBarCodeWidth(e.target.value)}
              autoComplete="off"
            />
          </FloatingLabel>
        </Col>
        <Col xs={12} md={1}>
          <ReactToPrint
            trigger={() => (
              <Button size="lg" variant="danger" className="w-100">
                PRINT
              </Button>
            )}
            content={() => myref.current}
            pageStyle={pageStyle}
          />
        </Col>
      </Row>

      {/* Barcode Display */}
      <Row className="mt-4">
        <div id="divcontents" ref={myref}>
          <Row className="g-3">
            {arr.map((m, i) => (
              <Col key={i} xs={6} sm={4} md={3} lg={2} className="text-center">
                <Barcode
                  value={m.barcode}
                  displayValue={false}
                  width={barCodeWidth}
                  height={barCodeHeight}
                />
                <br />
                <span style={{ fontSize: `${labelFontSize}px` }}>
                  {m.label}
                </span>
              </Col>
            ))}
          </Row>
        </div>
      </Row>
    </>
  );
}
